import React from 'react';
import './PrivacyPage.css';

const PrivacyPage: React.FC = () => {
  return (
    <div className="privacy-page-container">
      <div className="privacy-card-wrapper">
        <header className="privacy-header">
          <h1 className="privacy-title">Privacy Policy</h1>
          <div className="privacy-subtitle">Last updated: January 18, 2026</div>
          <div className="title-underline"></div>
        </header>

        <div className="privacy-body">
          <section className="privacy-intro-section">
            <p><strong>Colorfuel</strong> is committed to respecting your privacy. This Privacy Policy explains how we handle information when you use our website and services in the decentralized ecosystem.</p>
          </section>

          <div className="privacy-sections-container">
            <section className="privacy-item">
              <div className="item-number">01</div>
              <div className="item-content">
                <h2>Information Collection</h2>
                <p>As a blockchain-based service, we collect limited information to facilitate your experience:</p>
                <ul className="privacy-list">
                  <li>Public blockchain addresses used to interact with our platform.</li>
                  <li>Transaction data generated through interaction with our smart contracts.</li>
                  <li>Anonymized analytics data regarding site usage.</li>
                </ul>
                <p>We do not collect personal identification information beyond what is publicly visible on the blockchain.</p>
              </div>
            </section>

            <section className="privacy-item">
              <div className="item-number">02</div>
              <div className="item-content">
                <h2>Wallet Connections</h2>
                <p>Connecting your wallet is a secure and standard process:</p>
                <ul className="privacy-list">
                  <li>We only request <strong>view-only</strong> access to your public address.</li>
                  <li>We never have access to your private keys or seed phrases.</li>
                  <li>All transactions are signed directly through your chosen wallet provider.</li>
                </ul>
              </div>
            </section>

            <section className="privacy-item">
              <div className="item-number">03</div>
              <div className="item-content">
                <h2>Data Sharing</h2>
                <p>We value your privacy and do not sell your data. Information is only shared:</p>
                <ul className="privacy-list">
                  <li>When required by legal process or regulatory requirements.</li>
                  <li>With trusted service providers assisting in platform operations.</li>
                  <li>In aggregated, anonymous forms for performance analytics.</li>
                </ul>
              </div>
            </section>

            <section className="privacy-item">
              <div className="item-number">04</div>
              <div className="item-content">
                <h2>Blockchain Transparency</h2>
                <p>Please be aware that any information sent to the Ethereum or Solana blockchains is <strong>public and immutable</strong>. This includes your wallet address and transaction history. We recommend exercising caution with the data you associate with your on-chain identity.</p>
              </div>
            </section>

            <section className="privacy-item">
              <div className="item-number">05</div>
              <div className="item-content">
                <h2>Changes to Policy</h2>
                <p>We may update this policy periodically. Continued use of Colorfuel after modifications indicates your acceptance of the updated terms. We recommend reviewing this page occasionally.</p>
              </div>
            </section>
          </div>

          <footer className="privacy-page-footer">
            <div className="footer-contact-box">
              <p>Questions regarding our privacy practices? Reach out at</p>
              <a href="mailto:contact@colorfuel.art" className="contact-link">contact@colorfuel.art</a>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage; 